<div class="modal right" id="newDriver" tabindex="-1" role="dialog" aria-labelledby="newDriverLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content" id="print-content">
            <div class="modal-header hide-print">
                <div class="modal-title">
					<h4 id="newDriverLabel" ng-if="!worker.id">New Driver</h4>
                    <h4 id="newDriverLabel" ng-if="worker.id">Edit Driver</h4>
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="icon-close-circle"></i>
                </button>
            </div>
            <div class="modal-body order-detail-page" ng-if="worker">
                <div class="modal-body-container">
					<div class="tab-content">
						<div class="tab-pane active">
							<div class="row">
								<div class="col-md-12">
									<form ng-submit="saveWorker(worker)" class="form-horizontal allcp-form" autocomplete="off">
										<h4 style="font-size:13px">Driver Info</h4>
										<div class="row">
											<div class="col-md-6 pl15">
												<div class="form-group floating">
													<input type="text" ng-model="worker.first_name" class="form-control input-md" placeholder="First Name" required>
													<label>First Name</label>
												</div>
											</div>
											<div class="col-md-6 pr10">
												<div class="form-group floating">
													<input type="text" ng-model="worker.last_name" class="form-control input-md" placeholder="Last Name" required>
													<label>Last Name</label>
												</div>
											</div>
										</div>

										<div class="row">
											<div class="col-md-6 pl15">
												<div class="form-group floating">
													<input type="email" ng-model="worker.email" class="form-control input-md" placeholder="E-Mail" required>
													<label>E-Mail</label>
												</div>
											</div>
											<div class="col-md-6 pr10">
												<div class="form-group floating">
													<input type="text" ng-model="worker.phone_number" class="form-control input-md" ui-mask="(999) 999-9999"  ui-mask-placeholder ui-mask-placeholder-char=" " required>
													<label>Phone Number </label>
												</div>
											</div>
										</div>

										<div class="form-group floating">
											<input type="password" ng-required="!worker.id"  ng-model="worker.password" class="form-control input-md" placeholder="*********" required>
											<label>Password</label>
										</div>

				
										<div class="form-group floating">
											<input type="text" ng-model="worker.identification_number" class="form-control input-md" placeholder="ID (Passport Or Driving Licence)">
											<label>ID (Passport Or Driving Licence)</label>
										</div>

										<div class="form-group floating">
											<input type="checkbox"
												ng-model="worker.dispatcher"
												ng-checked="worker.dispatcher"
												id="dispatcher">
											<label for="dispatcher">Dispatcher</label>
										</div>
										<div class="form-group floating" ng-if="worker.dispatcher">
											<label>Dispatcher Stations </label>
											<ui-select ng-model="worker.stations" title="Dispatcher Stations" multiple>
												<ui-select-match placeholder="Dispatcher Stations...">{{ $item.code }}</ui-select-match>
												<ui-select-choices repeat="item as item in (stations | filter: $select.search) track by item.id">
													<div class="row mr10 ml10">
														<span ng-bind="item.code"></span>
													</div>
												</ui-select-choices>
											</ui-select>
										</div>

										<div class="form-group floating">
											<label>Offer Stations </label>
											<ui-select ng-model="worker.offer_stations" title="Offer Stations" multiple>
												<ui-select-match placeholder="Offer Stations...">{{ $item.code }}</ui-select-match>
												<ui-select-choices repeat="item as item in (stations | filter: $select.search) track by item.id">
													<div class="row mr10 ml10">
														<span ng-bind="item.code"></span>
													</div>
												</ui-select-choices>
											</ui-select>
										</div>

										<h4 style="font-size:13px">Address Info</h4>
										<div class="row">
											<div class="col-md-6 pl15">
												<div class="form-group floating">
													<input type="text" ng-model="worker.address" class="form-control input-md" placeholder="Street">
													<label>Street</label>
												</div>
											</div>
											<div class="col-md-6 pr10">
												<div class="form-group floating">
													<input type="text" ng-model="worker.address2" class="form-control input-md" placeholder="Apt, Suite, Building">
													<label>Apt, Suite, Building</label>
												</div>
											</div>
										</div>

										<div class="row">
											<div class="col-md-6 pl15">
												<div class="form-group floating">
													<input type="text" ng-model="worker.city" class="form-control input-md" placeholder="City">
													<label>City</label>
												</div>
											</div>
											<div class="col-md-6 pr10">
												<div class="form-group floating">
													<select ng-model="worker.state" class="gui-input" placeholder="State">
														<option value="">Select State</option>
														<option value="{{ state.name }}" ng-repeat="state in states track by $index">{{ state.name }}</option>
													</select>
												</div>
											</div>
										</div>

										<div class="form-group floating">
											<input type="text" ng-model="worker.zipcode" class="form-control input-md" placeholder="Zipcode">
											<label>Zipcode</label>
										</div>


										<h4 style="font-size:13px">Vehicle Info</h4>
										<div class="row">
											<div class="col-md-12 mb-3">
												<button 
													type="button" 
													ng-click="worker.vehicle = 'Scooter'" 
													ng-class="worker.vehicle == 'Scooter' ? 'blue' : ''" 
													class="hod-button">
													Scooter
												</button>
												<button 
													type="button" 
													ng-click="worker.vehicle = 'Bike'" 
													ng-class="worker.vehicle == 'Bike' ? 'blue' : ''" 
													class="hod-button">
													Bike
												</button>
												<button 
													type="button" 
													ng-click="worker.vehicle = 'Motorcycle'" 
													ng-class="worker.vehicle == 'Motorcycle' ? 'blue' : ''" 
													class="hod-button">
													Motorcycle
												</button>
											</div>

											<div class="col-md-12 mb-3">
												<button 
													type="button" 
													ng-click="worker.vehicle = 'Car'" 
													ng-class="worker.vehicle == 'Car' ? 'blue' : ''" 
													class="hod-button">
													Car
												</button>
												<button 
													type="button" 
													ng-click="worker.vehicle = 'Suv'" 
													ng-class="worker.vehicle == 'Suv' ? 'blue' : ''" 
													class="hod-button">
													Suv
												</button>
												<button 
													type="button" 
													ng-click="worker.vehicle = 'Van'" 
													ng-class="worker.vehicle == 'Van' ? 'blue' : ''" 
													class="hod-button">
													Van
												</button>
												<button 
													type="button" 
													ng-click="worker.vehicle = 'Truck'" 
													ng-class="worker.vehicle == 'Truck' ? 'blue' : ''" 
													class="hod-button">
													Truck
												</button>
											</div>
										</div>
										<div class="row">
											<div class="col-md-6 pl15">
												<div class="form-group floating">
													<input type="text" ng-model="worker.vehicle_year" class="form-control input-md" placeholder="Vehicle Year">
													<label>Vehicle Year</label>
												</div>
											</div>
											<div class="col-md-6 pr10">
												<div class="form-group floating">
													<input type="text" ng-model="worker.vehicle_make" class="form-control input-md" placeholder="Vehicle Make">
													<label>Vehicle Make</label>
												</div>
											</div>
										</div>

										<div class="form-group floating">
											<input type="text" ng-model="worker.vehicle_model" class="form-control input-md" placeholder="Vehicle Model">
											<label>Vehicle Model</label>
										</div>

										<h4 style="font-size:13px">Account Holder Name</h4>
										<div class="row">
											<div class="col-md-6 pl15">
												<div class="form-group floating">
													<input type="text" ng-model="worker.account_holder_name" class="form-control input-md" placeholder="Account Holder Name">
													<label>Account Holder Name</label>
												</div>
											</div>
											<div class="col-md-6 pr10">
												<div class="form-group floating">
													<input type="text" ng-model="worker.routing_number" class="form-control input-md" placeholder="Routing Number">
													<label>Routing Number</label>
												</div>
											</div>
										</div>

										<div class="form-group floating">
											<input type="text" ng-model="worker.account_number" class="form-control input-md" placeholder="Account Number">
											<label>Account Number</label>
										</div>

										<div class="form-group floating pln">
											<div class="col-md-12 pln">
												<button type="submit" class="hod-button blue" ng-disabled="loading">
													<span ng-if="!worker.id">CREATE</span>
                    								<span ng-if="worker.id">UPDATE</span>
												</a>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
            </div>
        </div>
    </div>
</div>
